<script>
import { setUserProfile } from '../api/users';
import zipcodes from 'zipcodes';

export default {
    name: 'CpProfileDialogZip',
    directives: {
        margin: require('../directives/margins').margin,
    },
    components: {
        CpBox: require('../box').default,
        CpBoxContent: require('../box-content').default,
        CpButton: require('../button').default,
        CpDialog: require('../dialog').default,
        CpTextInput: require('../inputs/text').default,
        CpDialog: require('../dialog').default,
        CpSelect: require('../select').default,
    },
    props: {
        states: Array,
        showZipDialog: Boolean,
        setCurrentUserZip: Function,
        handleZipDialog: Function,
        handleBannerZip: Function,
    },
    data() {
        return {
            address_zip: '',
            address_state: '',
            address_city: '',
            loadingUpdateProfile: false,
            errorUpdateProfileUser: null,
        };
    },
    computed: {
        invalidCity() {
            return this.address_city == null;
        },
        invalidState() {
            return this.address_state == null;
        },
        invalidZipcode() {
            return !/^[0-9]{5}(?:-[0-9]{4})?$/.test(this.address_zip);
        },
        invalidUpdatedProfile() {
            return (
                this.invalidCity || this.invalidState || this.invalidZipcode || this.address_city == '' || this.address_state == '' || this.address_zip == ''
            );
        },
    },
    methods: {
        updateUser() {
            this.loadingUpdateProfile = true;
            const { address_zip, address_state, address_city } = this;
            setUserProfile({ address_zip, address_state, address_city, unset_zipcode: false })
                .then(() => {
                    this.setCurrentUserZip(address_zip);
                    this.handleZipDialog(false);
                })
                .catch(({ message }) => {
                    this.errorUpdateProfileUser = 'Error: A problem occurred!';
                    console.error(message);
                })
                .finally(() => {
                    this.loadingUpdateProfile = false;
                    this.handleBannerZip(false);
                });
        },
        searchByZip(value) {
            const zip = zipcodes.lookup(value);
            if (zip) {
                this.address_city = zip.city;
                this.address_state = zip.state;
                this.address_zip = value;
            }
        },
    },
};
</script>

<template>
    <cp-dialog v-if="showZipDialog">
        <cp-box>
            <cp-box-content>
                <section style="margin: 4em 2.5em; max-width: 55ch; text-align: center">
                    <header class="heading-1">Update your profile!</header>
                    <br />
                    <svg
                        @click.prevent="handleZipDialog(false)"
                        class="close-svg-icon"
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
                        />
                    </svg>
                    <div class="share-network-list">
                        <div class="content-2">ZIP code:</div>
                        <cp-text-input
                            v-margin="0.3"
                            type="text"
                            v-model="address_zip"
                            placeholder="ZIP code"
                            @input="searchByZip"
                            :class="{ 'content-required': invalidZipcode && this.address_zip != '' }"
                            style="width: 100%"
                        />
                        <div class="content-2">City:</div>
                        <cp-text-input
                            v-margin="0.3"
                            type="text"
                            v-model="address_city"
                            placeholder="City"
                            :class="{ 'content-required': invalidCity }"
                            style="width: 100%"
                        />
                        <div class="content-2">State:</div>
                        <cp-select
                            v-model="address_state"
                            :class="{ 'content-required': invalidState }"
                            style="border-radius: 0px; height: 40px; width: 100%"
                            v-margin="0.3"
                        >
                            <option value>- Select -</option>
                            <option v-for="state in states" :value="state.abbreviation" :key="state.abbreviation">{{ state.name }}</option>
                        </cp-select>
                        <p v-if="errorUpdateProfileUser" style="color: red; width: 100%">{{ errorUpdateProfileUser }}</p>
                        <cp-button @click="updateUser" :disabled="invalidUpdatedProfile" style="width: 50%; margin-top: 15px" :loading="loadingUpdateProfile"
                            >Save</cp-button
                        >
                    </div>
                </section>
            </cp-box-content>
        </cp-box>
    </cp-dialog>
</template>

<style scoped>
.content-required {
    border: 1px solid red;
}
</style>
